module.exports = __webpack_public_path__ + "static/media/arbutus-greenway-rendering.6d414f2f.jpeg";